import { yupIgnore } from 'services/yup/helpers'
import { yupString } from 'services/yup/custom-schemas/string'
import { YupSchema } from 'services/yup/types'
import { yupObject } from 'services/yup'
import { CatalogItemBase } from 'services/api/entities/catalog/catalogItemBase/types/internal/catalogItemBase-models'

export const catalogItemBaseShapeVS: YupSchema<CatalogItemBase> =
  yupObject().shape({
    id: yupIgnore(),
    name: yupString().required(),
    updatedBy: yupIgnore(),
    updatedAt: yupIgnore(),
  })
